import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import {useAssortmentCardStore, useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import * as css from './HeaderPopoverContentPanel.css'

/// region Store

export class AssortmentCardHeaderPopoverContentPanelStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @observable foo = false

  @computed get bar() { return null }

  @action verb = () => {}
}

export const AssortmentCardHeaderPopoverContentPanelStoreContext = React.createContext<AssortmentCardHeaderPopoverContentPanelStore>(null)
export const useAssortmentCardHeaderPopoverContentPanelStore = () => React.useContext(AssortmentCardHeaderPopoverContentPanelStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const HeaderPopoverContentPanel = observer<MyProps>(function AssortmentCardHeaderPopoverContentPanel({className, ...props}) {
  const card = useAssortmentCardStore(),
    obsProps = useAsObservableSource({props, card}),
    store = useVipLocalStore((stores) => new AssortmentCardHeaderPopoverContentPanelStore(stores, obsProps)),
    {} = store,
    {title} = card

  useEffect(() => store.registerEffects(), [])

  return (
    <AssortmentCardHeaderPopoverContentPanelStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
        {/*<ToggleExpandButton tooltipPosition='right'/>*/}
      </div>
    </AssortmentCardHeaderPopoverContentPanelStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Assortments/AssortmentCard/Header/HeaderPopoverContentPanel.tsx